import React, { PureComponent } from 'react'

import { Flex } from '@stackhouse/styled-elements'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Modal from '@stackhouse/dashboard-components/Modal'
import ProgressCircle from '@stackhouse/dashboard-components/ProgressCircle'

import Loader from '@stackhouse/dashboard-components/Loader'


const ProgressModal = withDashboardContext(class extends PureComponent {

    constructor(props) {
        super(props)
        this.state = { progress: 0, showProgress: null }
    }

    componentDidMount() {
        const { client, url, close } = this.props

        this.downloadStart = +new Date()

        const config = { url, responseType: 'blob', onDownloadProgress: this.onDownloadProgress }
        return client(config).then(this.onDone).then(this.onDownloadComplete).then(close).catch(close)
    }

    onDownloadComplete = (response) => {
        const { fileName } = this.props

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
    }

    onDownloadProgress = (progressEvent) => {
        const nextState = {}
        const { showProgress } = this.state

        if (showProgress === null) {
            nextState.showProgress = progressEvent.total > 10000
        }

        if (showProgress || nextState.showProgress) {
            nextState.progress = progressEvent.loaded / progressEvent.total
        }

        return this.setState(nextState)
    }


    onDone = (response) => {
        const { downloadStart } = this

        if (+new Date() - downloadStart < 1000) {
            return new Promise(resolve => setTimeout(() => resolve(response), 1000 - (+new Date() - downloadStart)))
        }

        return Promise.resolve(response)
    }

    render() {
        const { progress, showProgress } = this.state
        if (showProgress === null) return null
        return showProgress === true
            ? (
                <Flex alignCenter justifyCenter p={'10%'} backgroundColor={'white'} borderRadius={10}>
                    <ProgressCircle progress={progress} />
                </Flex>
            )
            : (
                <Loader />
            )
    }
}, ({ client }) => ({ client }))


const DownloadWithProgress = ({ url, fileName, onSuccess }) => {
    return Modal.show(
        ({ close }) => (
            <ProgressModal close={close} onSuccess={onSuccess} url={url} fileName={fileName} />
        ),
        { target: 'root', animation: 'zoom', closeOnClick: false }
    )
}


export default DownloadWithProgress